import get from 'lodash/get';
/* global ADV */

const chartSettings = {
  chart: {
    type: 'areaspline',
    spacingRight: 20,
  },
  title: {
    text: '',
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  xAxis: {
    categories: [],
    gridLineWidth: 0,
    tickWidth: 0,
  },
  yAxis: {
    title: {
      text: '',
    },
    gridLineColor: '#ddd',
    gridLineDashStyle: 'Dot',
    gridLineWidth: 2,
    labels: {
      formatter() {
        return `$${ADV.util.short_number_format(this.value)}`;
      },
      style: {
        fontFamily: 'Open Sans, helvetica, sans-serif',
        fontSize: '13px',
        color: '#888',
      },
    },
  },
  series: [],
  tooltip: {
    useHTML: true,
    shadow: false,
    borderWidth: 0,
    backgroundColor: null,
    shared: true,
    formatter() {
      const proposedPlanTemplate = (isCurrentPlan, proposedPlan) => {
        if (isCurrentPlan) {
          return '';
        }
        if (proposedPlan) {
          return `
          <span>
            <div class="column-title" >Proposed</div>
            $${ADV.util.number_format(proposedPlan.y, 0)}
          </span>
        `;
        }
        return '';
      };

      const current = this.points.find(item => item.series.options.name === 'Current');
      const proposedPlan = this.points.find(item => item.series.options.name === 'Proposed');

      const isCurrentPlan = get(current, 'series.options.isCurrentPlan', false);

      const htmlString = `
        <div class="debt">
          <strong>${this.x}</strong>
          <b>
            <span class="${isCurrentPlan ? 'only-current-value' : ''}">
              <div class="column-title" >Current</div>
              $${ADV.util.number_format(current.y, 0)}
            </span>
            ${proposedPlanTemplate(isCurrentPlan, proposedPlan)}
          </b>
        <div>
      `;

      const currentHTML = [];
      const recommendedHTML = [];

      this.points.forEach(point => {
        const isCurrent = point.series.options.stack === 'current';
        const isProposed = point.series.options.stack === 'recommended';

        if (isCurrent && point.y !== 0) {
          currentHTML.push(`
            <li>
              <b>
                $${ADV.util.number_format(point.y, 0)}
              </b>
              ${point.series.name}
            </li>
          `);
        } else if (isProposed && point.y !== 0) {
          recommendedHTML.push(`
            <li>
              <b>
                $${ADV.util.number_format(point.y, 0)}
              </b>
              ${point.series.name}
            </li>
          `);
        }
      });
      const finalHtmlString = `
        ${htmlString}
          <ul class="left">
            ${currentHTML.join('')}
          </ul>
        ${isCurrentPlan ? '' : `<ul class="right">${recommendedHTML.join('')}</ul>`}
      `;
      return finalHtmlString;
    },
  },
  plotOptions: {
    areaspline: {
      lineWidth: 4,
      states: {
        hover: {
          lineWidth: 3,
        },
      },
      marker: {
        enabled: false,
      },
      pointPlacement: 'on',
    },
  },
};

export default chartSettings;
